import { Input } from 'formik-antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toInputUppercase } from 'utils/text';

const StyledInput = styled(Input)`
	/* Only apply these styles when type is number */
	&[type='number'] {
		/* For Chrome, Safari, Edge, Opera */
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		/* For Firefox */
		-moz-appearance: textfield;
	}
`;

export default function CustomInput({
	type = 'text',
	name,
	onChange = () => {},
	placeholder = '',
	isCaps = false,
	...rest
}) {
	return (
		<StyledInput
			{...rest}
			type={type}
			name={name}
			onChange={onChange}
			placeholder={placeholder}
			onFocus={(e) => {
				e.target.autoComplete = 'new-password';
			}}
			onInput={isCaps ? toInputUppercase : null}
		/>
	);
}

CustomInput.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	isCaps: PropTypes.bool,
	placeholder: PropTypes.string,
};
